// extracted by mini-css-extract-plugin
export default {"container":"closed-label_container__4yfzJ"};